import { RemoteDiagnosticsVddGenericStructure, Vdd } from '@vi-iot/client';

export interface VddCurrentAndSnapshotValue {
  currentValue: RemoteDiagnosticsVddGenericStructure[];
  snapshotValue: RemoteDiagnosticsVddGenericStructure[];
}

export enum SnapshotType {
  SNAPSHOT = 'snapshot',
  BACKUP = 'backup',
}

export interface SnapshotDetailsDemoMode {
  id: string;
  vddList: Vdd[];
}

export interface SnapshotUpdateResponseTransformed {
  failed: boolean;
}
